import { specialInfo } from '@/api/special';
/* 图书类型 图书类型：53-图书，54-有声书，55-视频，64-条目文档对应字典book_type */
export const BookType = {
  ebook: 53,
  dbook: 101,
  sbook: 54,
  course: 55,
  other: 64,
  special: 1,
  none: '',
};

/* 书类型对应详情跳转地址 */
export const BookTypeDetail = {
  53: '/detail',
  101: '/szjcDetail',
  54: '/soundBook',
  55: '/courseBook',
  64: '/other',
  0: '/special',
};

/** 是否为第三方教材 */
export function isThirdBook (item) {
  return !!(item && item.thirdBookSource && item.thirdBookUrl);
}

/**
 * 全局开关：是否列表直接跳第三方链接
 * true（默认）：直接打开 thirdBookUrl
 * false：进站内详情，详情页点「立即阅读」再跳外链
 */
export function isThirdBookDirectJump () {
  const conf = window.__appBaseConfig__ || {};
  if (conf.THIRD_BOOK_DIRECT_JUMP === undefined) return true;
  return !!conf.THIRD_BOOK_DIRECT_JUMP;
}

/**
 * 第三方教材处理：
 * - 开关开：直接打开外链，返回 true
 * - 开关关或非第三方：返回 false，由调用方继续走详情
 */
export function tryOpenThirdBook (item) {
  if (!isThirdBook(item)) return false;
  if (isThirdBookDirectJump()) {
    window.open(item.thirdBookUrl, '_blank');
    return true;
  }
  return false;
}

/** 开关关闭时，详情 URL 拼上第三方参数 */
export function appendThirdBookQuery (url, item) {
  if (!isThirdBook(item) || isThirdBookDirectJump()) return url;
  const sep = url.includes('?') ? '&' : '?';
  return (
    `${url}${sep}thirdBookUrl=${encodeURIComponent(item.thirdBookUrl)}` +
    `&thirdBookSource=${encodeURIComponent(item.thirdBookSource)}`
  );
}

/** 生成图书详情跳转地址（含第三方 query） */
export function getBookDetailUrl (item) {
  const jumpUrl = BookTypeDetail[item.objectType || item.ObjectType];
  const id = item.bookId || item.resourceId || item.Id || item.id;
  const url = `${jumpUrl}?id=${id}`;
  return appendThirdBookQuery(url, item);
}

/** 站内详情新开页 */
export function openBookDetailPage (url, content, isNewType = 'newTab') {
  if (!url || !content || !content.$router) return;
  const href = content.$router.resolve(url);
  const routePath = href.resolved.fullPath;
  if (isNewType == 'newTab') {
    const local = window.location;
    const toPath = local.origin + local.pathname + `#${routePath}`;
    window.open(toPath, '_blank');
  } else if (isNewType == 'replace') {
    content.$router.replace(routePath);
  } else if (isNewType == 'push') {
    content.$router.push(routePath);
  }
}

export function goDetail (item, content) {
  if (item.deleteFlag === '1') {
    content.$toast('本资源已删除,请联系平台客服');
    return;
  }

  if (
    (item.IsOnShelf !== undefined && item.IsOnShelf !== '1') ||
    item.deleteFlag === '1'
  ) {
    content.$toast('本资源已下架,请联系平台客服');
    return;
  }

  if (tryOpenThirdBook(item)) return;

  openBookDetailPage(getBookDetailUrl(item), content);
}

export function openNewDetail (item, content) {
  goDetail(item, content);
}

/* 专题跳转处理 */
export function specialJump (book, content) {
  async function getSpecialInfo () {
    const { code, msg, data } = await specialInfo({
      id: book.resourceId || book.specialSubjectId || book.Id || book.id,
    });
    // console.log('code, msg, rows', code, msg, rows);
    if (code === 200) {
      return data;
    } else {
      Toast(msg);
      return {};
    }
  }
  async function goDetail () {
    const { resourceType, id } = await getSpecialInfo();
    if (resourceType * 1 === 2 || resourceType * 1 === 3) {
      content.$router.push(`/special/detail?id=${id}`);
    } else {
      content.$router.push(`/special/subSpecial?id=${id}`);
    }
  }

  goDetail();
}
